import { create } from 'zustand';

export const useUIStore = create((set) => ({
  activeSectionChats: 'Aguardando',
  showNewChat: false,
  initialParamsForNewChat: null,

  isEditingProfile: false,
  isEditingProfileChat: false,
  isEditingProfileGroupChat: false,

  openScheduleMessage: false,

  isRecordingAudio: false,

  // Alert (from useAlert hook equivalent)
  alert: {
    open: false,
    message: '',
    severity: 'success',
    duration: 5000,
  },

  // Setters
  setActiveSectionChats: (section) => set({ activeSectionChats: section }),
  setShowNewChat: (show) => set({ showNewChat: show }),
  setInitialParamsForNewChat: (params) => set({ initialParamsForNewChat: params }),
  setIsEditingProfile: (editing) => set({ isEditingProfile: editing }),
  setIsEditingProfileChat: (editing) => set({ isEditingProfileChat: editing }),
  setIsEditingProfileGroupChat: (editing) => set({ isEditingProfileGroupChat: editing }),
  setOpenScheduleMessage: (open) => set({ openScheduleMessage: open }),
  setIsRecordingAudio: (recording) => set({ isRecordingAudio: recording }),

  // Alert actions
  showAlert: (message, severity, duration = 5000) => {
    set({
      alert: {
        open: true,
        message,
        severity,
        duration,
      },
    });
    if (duration) {
      setTimeout(() => {
        set((state) => ({
          alert: {
            ...state.alert,
            open: false,
          },
        }));
      }, duration);
    }
  },
  hideAlert: () => set((state) => ({
    alert: {
      ...state.alert,
      open: false,
    },
  })),
}));
